import React from "react";
import Button from "../";
import cx from "../../../utils/cx";
import s from "./index.css";

export default ({ active, className, ...props }) => (
  <Button
    className={cx({
      [s.text]: true,
      [s.textActive]: active,
      [className]: className
    })}
    hoverClassName={s.textHover}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/Buttons/Text/index.js